<template>
  <div v-if="cashInMethod">
    <cash-in-method-details
      :data-cash-in-method.sync="cashInMethod"
      @update:dataCashInMethod="updateCashInMethod"
    />
  </div>
</template>

<script>
import CashInMethodDetails from "./details";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: { CashInMethodDetails },
  data: () => ({
    cashInMethod: null,
  }),
  mounted() {
    this.fetchCashInMethod();
  },
  watch: {
    id() {
      this.fetchCashInMethod();
    },
  },
  methods: {
    fetchCashInMethod() {
      this.$http
        .get(`/api/v1/transactions/cryptoCashInMethods/${this.id}`)
        .then((cashInMethod) => (this.cashInMethod = cashInMethod));
    },
    updateCashInMethod(cashInMethod) {
      if (cashInMethod) {
        this.cashInMethod = cashInMethod;
      }
    },
  },
};
</script>

<style></style>
